export const BASE_URL = "https://tire-fill-tool-beta-a54b5e2a0d2f.herokuapp.com";
//export const BASE_URL = "http://localhost:3001";